import React from 'react';
import classnames from 'classnames';

class RadioToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: null
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    if (this.props.onChange) {
			this.props.onChange(e.target.value);
		}
    // this.props.onChange(this.props.id, e.target.value);
    this.setState({
      active: e.target.value
    });
  }

  render() {

    let nodes = this.props.items.map((items, index) => {
      return (
      <li key={index}>
        <input
          id={this.props.name + index}
          className={classnames('radio-toggle--input', {active: this.state.active == items.value})}
          type="radio"
          onChange={this.handleClick}
          value={items.value}
          name={this.props.name + index}
        />
        <label htmlFor={this.props.name + index}>{items.label}</label>
      </li>
    );
    });

    return (
      <div className="control simple-radio-input">
        <label className="label">{this.props.controlLabel}</label>
        <ul className="options">
          {nodes}
        </ul>
      </div>
        );
  }
}

RadioToggle.defaultProps = {
    items: [
      {value: 1, label: "Yes"},
      {value: 0, label: "No"}
    ],
    name: '',
    controlLabel: ''
};

RadioToggle.propTypes={
  name: React.PropTypes.string.isRequired,
  items: React.PropTypes.array.isRequired,
  onChange: React.PropTypes.func.isRequired,
  controlLabel: React.PropTypes.string.isRequired
};

export default RadioToggle;



// WEBPACK FOOTER //
// ./src/components/forms/RadioToggle.js